<template>
    <div v-loading="loading">
        <el-form style="margin-top: 20px;" ref="form" :model="formData" label-width="70px">
            <div class="flex">
                <!-- <div style="line-height: 40px;width: 112px;font-weight: 600;color: #242627;">性质标签：</div> -->
                <div class="flex">

                    <!-- <div class="form-item">
                        <el-form-item label="地产类：">
                            <el-cascader :options="estateTypeList" size="medium" @change="changeEstateType"
                                :props="{ checkStrictly: true }" clearable></el-cascader>
                        </el-form-item>
                    </div>
                    <div class="form-item">
                        <el-form-item label="产业类：">
                            <el-cascader :options="industryTypeList" size="medium" @change="changeIndustryType"
                                :props="{ checkStrictly: true }" clearable></el-cascader>
                        </el-form-item>
                    </div>
                    <div class="form-item">
                        <el-form-item label="文旅类：">
                            <el-cascader :options="travelTypeList" size="medium" @change="changeTravelType"
                                :props="{ checkStrictly: true }" clearable></el-cascader>
                        </el-form-item>
                    </div>
                    <div class="form-item">
                        <el-form-item label="康养类：">
                            <el-cascader :options="healthTypeList" size="medium" @change="changeHealthType"
                                :props="{ checkStrictly: true }" clearable></el-cascader>
                        </el-form-item>
                    </div>
                    <div class="form-item">
                        <el-form-item label="专题类：">
                            <el-cascader :options="specialTypeList" size="medium" @change="changeSpecialType"
                                :props="{ checkStrictly: true }" clearable></el-cascader>
                        </el-form-item>
                    </div> -->
                </div>

            </div>
            <div class="flex">
                <!-- <div style="line-height: 40px;font-weight: 600;color: #242627;">监测周期：</div> -->
                <div class="flex justify-between" style="width: 93.3%;">
                    <div class="flex">
                        <div class="form-item">
                            <el-form-item label="性质标签：" label-width="100px">
                                <el-cascader :options="stageLabelList" size="small" placeholder="请选择报告性质"
                                    :props="{ checkStrictly: true }" @change="getStageLabel" clearable></el-cascader>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="监测周期：" label-width="100px">
                                <el-cascader :options="caseLabelList" @change="changeCaseLabel" size="medium"
                                    style="width: 150px;" :props="{ checkStrictly: true }" clearable></el-cascader>
                            </el-form-item>
                        </div>
                    </div>

                    <div>
                        <el-form-item>
                            <el-button @click="search" type="primary"><i class="el-icon-search"></i>搜索</el-button>
                        </el-form-item>
                    </div>

                </div>
            </div>
        </el-form>
        <div class="fenjie-line"></div>
        <div class="content-title">
            <div class="title-line"></div>
            <div class="title">筛选内容</div>
        </div>
        <div class="a-content flex">
            <div class="a-content-item flex" v-for="(item, index) in dataList" :key="index" @click="detail(item.id)">
                <img class="a-content-img" :src="item.coverUrl" />
                <img v-if="item.isPut == 1" class="is-put" src="../../../../assets//icon//icon-isput.png" />
                <div class="a-content-con">
                    <div class="a-content-title">
                        {{ item.title }}
                    </div>
                    <div class="a-content-text">
                        {{ item.introduction }}
                    </div>
                    <div class="a-content-price">￥<span style="font-size: 20px;font-weight: 600;">{{ item.webPrice
                            }}</span>
                    </div>
                </div>
            </div>
            <div class="flex justify-content" style="width: 100%;">
                <el-empty v-if="dataList.length == 0" :image-size="200"></el-empty>
            </div>
        </div>
        <div class="flex justify-content">
            <el-pagination background layout="prev, pager, next" @current-change="changePage" :page-size="10"
                :total="total">
            </el-pagination>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {

            tabList2: [{
                url: '',
                label: '工作成果库'
            }, {
                url: '',
                label: '监测周期库'
            }, {
                url: '',
                label: '学习充电库'
            }],
            activeIndex: 0,
            dataList: [],
            total: 0,
            formData: {
                type: 1,
                title: '',
                caseLabel: '',
                stageLabel: '',
                estateType: '',
                industryType: '',
                travelType: '',
                healthType: '',
                specialType: '',
                limit: 10,
                page: 1
            },
            estateTypeList: [],
            industryTypeList: [],
            travelTypeList: [],
            healthTypeList: [],
            specialTypeList: [],
            stageLabelList: [],
            caseLabelList: [
                {
                    value: '周报',
                    label: '周报',
                }, {
                    value: '月报',
                    label: '月报',
                }, {
                    value: '季报',
                    label: '季报',
                }, {
                    value: '半年报',
                    label: '半年报',
                }, {
                    value: '年报',
                    label: '年报',
                }
            ],
            stageLabelList: [{
                value: '地产类',
                label: '地产类',
            }, {
                value: '产业类',
                label: '产业类',
            }, {
                value: '文旅类',
                label: '文旅类',
            }, {
                value: '其他专题',
                label: '其他专题',
            }],
            loading: false
        }
    },
    created() {
        this.getLabelList()
        // this.getCaseLabelList()
        this.loadData()
    },
    methods: {
        loadData() {
            let that = this
            this.loading = true
            that.apis.caseList(this.formData).then(res => {
                this.loading = false
                that.total = res.count
                that.dataList = res.data
            })
        },
        // 详情
        detail(id) {
            if (this.$store.state.userId) {
                this.$router.push({
                    path: '/detail',
                    query: { id: id, type: 1 }
                })
                // let routeUrl = this.$router.resolve({
                //     path: "/detail",
                //     query: { id: id, type: 1 },
                // });
                // window.open(routeUrl.href, "_blank");
            } else {
                this.$emit('loginStatus', true)
            }

        },
        // 性质标签
        getLabelList() {
            let that = this
            let queryParam = {
                type: "propertyLabel",
            };
            that.apis.queryLabel(queryParam).then((res) => {
                res.data.forEach(element => {
                    if (element.label == '地产类') {
                        that.estateTypeList = element.children
                    } else if (element.label == '产业类') {
                        that.industryTypeList = element.children
                    } else if (element.label == '文旅类') {
                        that.travelTypeList = element.children
                    } else if (element.label == '康养类') {
                        that.healthTypeList = element.children
                    } else if (element.label == '专题类') {
                        that.specialTypeList = element.children
                    }
                });
            });
        },
        // 案例标签
        getCaseLabelList() {
            let that = this
            let queryParam = {
                type: "caseLabel",
            };
            that.apis.queryLabel(queryParam).then((res) => {
                that.caseLabelList = res.data
            });
        },
        // 地产类
        changeEstateType(e) {
            this.formData.estateType = e[e.length - 1]
        },
        // 产业类
        changeIndustryType(e) {
            this.formData.industryType = e[e.length - 1]
        },
        // 文旅类
        changeTravelType(e) {
            this.formData.travelType = e[e.length - 1]
        },
        // 康养类
        changeHealthType(e) {
            this.formData.healthType = e[e.length - 1]
        },
        // 专题类
        changeSpecialType(e) {
            this.formData.specialType = e[e.length - 1]
        },
        // 案例标签
        changeCaseLabel(e) {
            this.formData.caseLabel = e[e.length - 1]
        },
        // 报告性质
        getStageLabel(e) {
            this.formData.stageLabel = e[e.length - 1]
        },
        // 搜索
        search() {
            this.loadData()
        },
        // 搜索标题
        searchTitle(title) {
            this.formData.title = title
            this.loadData()
        },
        // 分页
        changePage(e) {
            this.formData.page = e
            this.loadData()
        }


    },

}
</script>


// WEBPACK FOOTER //
// src/views/index/components/list/case.vue